import React from "react";
import { List, ListItem, ListItemText, Stack } from "@mui/material";
import Avatar from "../../../../../../components/Avatar";
import { hasImage } from "../../../../../../utils/helpers";
import CustomMenu from "../../../../../../components/Menu";
import { CustomTextField } from "../../../../../../components/TextField";

const MentionList = ({
  mentionListVisible,
  anchorEl,
  elementPos,
  handleMentionClose,
  sortUser,
  handleChange,
  selectedUserForTag,
  handleUserSelect,
}) => {
  return (
    <CustomMenu
      open={mentionListVisible}
      anchorEl={anchorEl}
      isApplyCustomMenuCss={false}
      sx={{
        "& .MuiPaper-root": {
          top: `${elementPos?.top}px !important`,
          left: `${elementPos?.left}px !important`,
        },
      }}
      onClose={handleMentionClose}>
      <Stack alignItems="center" mx={1}>
        <CustomTextField
          placeholder="search..."
          fullWidth
          autoFocus
          value={sortUser}
          onChange={handleChange}
          sx={{
            "& .MuiInputBase-input": {
              padding: "8px 10px",
            },
          }}
        />
      </Stack>
      <List
        sx={{
          maxHeight: "200px",
          overflow: "auto",
          paddingTop: "0px !important",
        }}>
        <List>
          {selectedUserForTag.length > 0 ? (
            selectedUserForTag?.map((user) => (
              <ListItem
                button
                key={`mention-user-list-item-${user?.id}`}
                onClick={() => handleUserSelect(user)}>
                <Avatar
                  title={`${user?.first_name} ${user?.last_name}`}
                  user_image={user?.user_image}
                  className="user-avatar"
                  style={
                    !hasImage(user?.user_image) && {
                      bgcolor: user?.profile_color?.background,
                      color: user?.profile_color?.text,
                    }
                  }>
                  {user?.username?.split(" ").length === 2
                    ? user?.username?.split(" ")[0]?.charAt(0) +
                      user?.username?.split(" ")[1]?.charAt(0)
                    : user?.username.charAt(0) || ""}
                </Avatar>
                <ListItemText
                  sx={{ marginLeft: "8px" }}
                  primary={user?.username}
                />
              </ListItem>
            ))
          ) : (
            <ListItem>
              <ListItemText
                primary="No cards found"
                sx={{ textAlign: "center" }}
              />
            </ListItem>
          )}
        </List>
      </List>
    </CustomMenu>
  );
};

export default MentionList;
